import { Transition } from '@headlessui/react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { clsx } from 'clsx'
import Image from 'next/image'
import { Dispatch, Fragment, SetStateAction } from 'react'
import RoundClose from '../../Icon/RoundClose'

export type CharacterItemSchema = {
  id: string
  name: string
  imageURL: string
  user: {
    displayName: string
  }
}

type Props = {
  characterInfo: CharacterItemSchema
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export default function CharacterDetailModal({
  characterInfo,
  isOpen,
  setIsOpen,
}: Props) {
  return (
    <DialogPrimitive.Root open={isOpen} onOpenChange={setIsOpen}>
      <DialogPrimitive.Portal forceMount>
        <Transition.Root show={isOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <DialogPrimitive.Overlay
              forceMount
              className="fixed inset-0 z-20 bg-black/50"
            />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95">
            <DialogPrimitive.Content
              forceMount
              className={clsx(
                'fixed z-50',
                'h-592 w-894 overflow-hidden rounded-39 max-lg:aspect-square max-lg:w-[calc(100vw-20px)]',
                'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
                'bg-white',
              )}>
              <Image
                src={characterInfo.imageURL}
                alt={characterInfo.name}
                fill
                className="object-cover object-center"
              />
              <DialogPrimitive.Close
                className={clsx(
                  'absolute right-25 top-24 inline-flex items-center justify-center rounded-full p-1',
                )}>
                <RoundClose />
              </DialogPrimitive.Close>
            </DialogPrimitive.Content>
          </Transition.Child>
        </Transition.Root>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}
